import {
  CREATE_SALES_INVOICE_REQUESTED,
  CREATE_SALES_INVOICE_SUCCESS,
  CREATE_SALES_INVOICE_ERRORED,
  GET_SALES_INVOICE_REQUESTED,
  GET_SALES_INVOICE_SUCCESS,
  GET_SALES_INVOICE_ERRORED,
  GET_SALES_INVOICE_DETAILS_REQUESTED,
  GET_SALES_INVOICE_DETAILS_SUCCESS,
  GET_SALES_INVOICE_DETAILS_ERRORED,
  UPDATE_SALES_INVOICE_REQUESTED,
  UPDATE_SALES_INVOICE_SUCCESS,
  UPDATE_SALES_INVOICE_ERRORED,
  DELETE_SALES_INVOICE_REQUESTED,
  DELETE_SALES_INVOICE_SUCCESS,
  DELETE_SALES_INVOICE_ERRORED,
  RESET_SALES_INVOICE,
} from "../constant/action-types";

import axios from "axios";

import { showSnackbar } from "../../../../actions/action-snackbar";

import configureStore from "../../../../store/configureStore";

const store = configureStore();

export const create_sales_invoice_requested = () => ({
  type: CREATE_SALES_INVOICE_REQUESTED,
});

export const create_sales_invoice_success = () => ({
  type: CREATE_SALES_INVOICE_SUCCESS,
});

export const create_sales_invoice_errored = (error) => ({
  type: CREATE_SALES_INVOICE_ERRORED,
  error,
});

export const get_sales_invoice_requested = () => ({
  type: GET_SALES_INVOICE_REQUESTED,
});

export const get_sales_invoice_success = (payload) => ({
  type: GET_SALES_INVOICE_SUCCESS,
  payload,
});

export const get_sales_invoice_errored = (error) => ({
  type: GET_SALES_INVOICE_ERRORED,
  error,
});

export const get_sales_invoice_details_requested = () => ({
  type: GET_SALES_INVOICE_DETAILS_REQUESTED,
});

export const get_sales_invoice_details_success = (payload) => ({
  type: GET_SALES_INVOICE_DETAILS_SUCCESS,
  payload,
});

export const get_sales_invoice_details_errored = (error) => ({
  type: GET_SALES_INVOICE_DETAILS_ERRORED,
  error,
});

export const update_sales_invoice_requested = () => ({
  type: UPDATE_SALES_INVOICE_REQUESTED,
});

export const update_sales_invoice_success = (payload) => ({
  type: UPDATE_SALES_INVOICE_SUCCESS,
  payload,
});

export const update_sales_invoice_errored = (error) => ({
  type: UPDATE_SALES_INVOICE_ERRORED,
  error,
});

export const delete_sales_invoice_requested = () => ({
  type: DELETE_SALES_INVOICE_REQUESTED,
});

export const delete_sales_invoice_success = (payload) => ({
  type: DELETE_SALES_INVOICE_SUCCESS,
  payload,
});

export const delete_sales_invoice_errored = (error) => ({
  type: DELETE_SALES_INVOICE_ERRORED,
  error,
});

export const reset_sales_invoice = () => ({
  type: RESET_SALES_INVOICE,
});

export const create_sales_invoice =
  (payload, activeOuid) => async (dispatch) => {
    dispatch(create_sales_invoice_requested());
    console.log(`Create sales invoice`);
    console.log("activeOuid", activeOuid);
    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/salesinvoices`;
      const method = "post";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
        },
      };
      return axios[method](url, payload, axiosHeader)
        .then((response) => {
          console.log("sales_invoice created successfully");
          dispatch(
            showSnackbar("sales invoice created successfully", "success")
          );
          dispatch(create_sales_invoice_success(response));
          dispatch(get_sales_invoice("", activeOuid));
        })
        .catch((err) => {
          console.log("sales invoice creation Failed");
          // console.error('ErrorLog : ', JSON.stringify(err));
          dispatch(showSnackbar("sales invoice creation Failed", "error"));
          dispatch(create_sales_invoice_errored(err));
        });
    }
    return null;
  };

export const get_sales_invoice = (query, activeOuid) => async (dispatch) => {
  dispatch(get_sales_invoice_requested());
  const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
  console.log(`accountsApiEndpoint`, accountsApiEndpoint);
  console.log(`credentials`, credentials);

  if (accountsApiEndpoint && credentials) {
    const jwt = `${credentials.idToken.jwtToken}`;
    let url = `${accountsApiEndpoint}/salesinvoices${query}`;

    const method = "get";
    const axiosHeader = {
      headers: {
        Authorization: jwt,
        "x-ouid": activeOuid,
      },
    };
    return axios[method](url, axiosHeader)
      .then((response) => {
        console.log("Get sales invoice Success", response.data);
        dispatch(get_sales_invoice_success(response.data.items));
      })
      .catch((err) => {
        console.log("Get sales invoice Failed");
        if (err.response) {
          var data = err.response.data;
          dispatch(showSnackbar(data.error, "error"));
        } else {
          dispatch(showSnackbar("Get sales invoice Failed", "error"));
        }
        dispatch(get_sales_invoice_errored(err));
      });
  }
  return null;
};

export const get_sales_invoice_details =
  (invoiceId, activeOuid) => async (dispatch) => {
    dispatch(get_sales_invoice_details_requested());
    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    console.log(`accountsApiEndpoint`, accountsApiEndpoint);
    console.log(`credentials`, credentials);

    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/salesinvoices/id/${invoiceId}`;

      const method = "get";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
        },
      };
      return axios[method](url, axiosHeader)
        .then((response) => {
          console.log("Get sales invoice Success", response.data);
          dispatch(get_sales_invoice_details_success(response.data));
        })
        .catch((err) => {
          console.log("Get sales invoice Failed");
          if (err.response) {
            var data = err.response.data;
            dispatch(showSnackbar(data.error, "error"));
          } else {
            dispatch(showSnackbar("Get sales invoice Failed", "error"));
          }
          dispatch(get_sales_invoice_details_errored(err));
        });
    }
    return null;
  };

export const update_sales_invoice =
  (payload, invoiceId, activeOuid) => async (dispatch) => {
    dispatch(update_sales_invoice_requested());
    console.log(`update_sales_invoice`);

    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/salesinvoices/id/${invoiceId}`;
      const { activeOuid, activeOuidChain } = store.getState().permission;
      const method = "put";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
          "x-ouidchain": activeOuidChain,
        },
      };
      return axios[method](url, payload, axiosHeader)
        .then((response) => {
          console.log("sales invoice Updation Success");
          dispatch(
            showSnackbar("sales invoice Updated Successfully", "success")
          );
          dispatch(update_sales_invoice_success());
        })
        .catch((err) => {
          console.log("sales invoice updation Failed");
          dispatch(showSnackbar("sales invoice updation Failed", "error"));
          dispatch(update_sales_invoice_errored(err));
        });
    }
    return null;
  };
